
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoshirdiinnovabooking() {



    const cardData =
    {
        keyword: ' Pune to Shirdi Innova Cab Booking',
        heading: 'Prince Cabs: Pune to Shirdi Innova Cab Booking',
        headingDescription: 'Prince Cabs provides dependable Pune to Shirdi Innova Cab Booking, ideal for Sai Baba temple visits, family trips, and pilgrimage tours. Our spacious Innova and Innova Crysta vehicles are well-maintained and equipped with modern amenities, ensuring a safe and comfortable ride on the Pune–Shirdi route. With professional chauffeurs, timely pickups, and flexible schedules, we make your journey hassle-free and convenient. Choose Prince Cabs’ trusted Innova cab booking service from Pune to Shirdi for comfort, reliability, and affordable fares.',

        top: 'Top Places to Visit in Shirdi with Prince Cabs',

   "topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Sai Baba Samadhi Mandir is the heart of Shirdi, where the mortal remains of Shri Sai Baba are enshrined. Built with white marble, the temple attracts millions of devotees annually. Daily aartis like Kakad Aarti and Shej Aarti create a divine atmosphere. Pilgrims often wait hours for darshan, yet the spiritual energy makes it worthwhile. The idol of Sai Baba is adorned with gold and precious jewels. It is the most sacred and visited spot in Shirdi."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai is the mosque where Sai Baba spent a major part of his life, offering solace and guidance to his followers. The sacred dhuni (fire) lit by Baba still burns here and is believed to bless devotees with Udi (sacred ash). Inside the mosque, Baba performed miracles and healed people. The site has photographs, palkhi, and sacred stones associated with Baba. It is deeply revered as a symbol of faith and unity. Dwarkamai reflects Sai Baba’s inclusive philosophy."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the place where Sai Baba used to rest every alternate night, and it remains an important pilgrimage spot. The palkhi procession of Sai Baba still takes place here on Thursdays. The small structure houses Baba’s wooden chair, bed, and portraits. Devotees feel a strong spiritual connection inside. It is located close to Dwarkamai and the Samadhi Mandir, making it easy to visit. Chavadi is a reminder of Baba’s simplicity and divine presence."
  },
  {
    "title": "Khandoba Temple",
    "description": "The Khandoba Temple in Shirdi is historically significant as it was here that Sai Baba was first recognized as a saint. The priest Mhalsapati greeted him with the words 'Aao Sai,' giving him the name by which the world remembers him today. The temple is dedicated to Lord Khandoba, a form of Lord Shiva. It is a small but powerful shrine with deep spiritual value. Pilgrims stop here to honor its connection with Sai Baba’s arrival in Shirdi. The temple blends devotion and history."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a unique theme park that recreates life scenes and stories of Sai Baba through statues and exhibits. Spread across a green landscape, it educates visitors about Baba’s miracles and his bond with devotees. Families enjoy the village-like ambiance, gardens, and interactive displays. It combines spirituality with entertainment, making it popular among children and tourists. The village also offers food and resting areas. It is both devotional and recreational."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan is the spot where Sai Baba was first seen meditating under a neem tree when he arrived in Shirdi as a young ascetic. Devotees believe the neem leaves here have medicinal properties. A small shrine now marks the place, housing a marble idol of Sai Baba, a shivling, and photos of saints. Pilgrims light incense sticks at Gurusthan for blessings. The peaceful setting makes it ideal for prayer and meditation. It is considered the starting point of Sai Baba’s divine journey in Shirdi."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a garden where Sai Baba used to spend time watering plants and meditating. The Nanda Deep, a lamp lit by Baba himself, still burns here continuously. The garden is beautifully maintained with pathways, greenery, and flowers. Devotees feel calm and refreshed while strolling through it. It reflects Baba’s love for nature and simplicity. Lendi Baug is both spiritual and scenic."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy is a popular water and amusement park located near Shirdi, offering a fun-filled break for families and children. It features thrilling water slides, wave pools, rain dance, and adventure rides. The park is well-maintained and adds a recreational element to a spiritual trip. Visitors often combine temple darshan with a day of relaxation here. It is perfect for those traveling with kids. Wet N Joy balances devotion with leisure."
  },
  {
    "title": "Upasani Maharaj Ashram",
    "description": "Located in Sakori near Shirdi, the Upasani Maharaj Ashram is dedicated to Sai Baba’s prominent disciple, Upasani Maharaj. The ashram includes meditation halls, temples, and accommodations for devotees. Visitors learn about Maharaj’s teachings and his close association with Sai Baba. The peaceful environment attracts spiritual seekers. It is an important site for those exploring Shirdi’s extended spiritual circle. The ashram adds depth to the Shirdi pilgrimage."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located about 70 km from Shirdi, Shani Shingnapur is a famous village dedicated to Lord Shani. The temple here is unique as the deity is housed in the open air without a roof. The village is also known for having no doors in houses, symbolizing faith in Lord Shani’s protection. Devotees from Shirdi often visit as part of their pilgrimage circuit. Saturdays are especially crowded with worshippers. Shani Shingnapur is a powerful spiritual destination connected with Shirdi."
  }
],

"services": [
    {
        "name": "Pune to Shirdi Cabs Round Trip",
        "description": "Enjoy a comfortable and convenient round trip from Pune to Shirdi with our premium cab service. Ideal for pilgrims, families, and group travelers, our round trip packages offer flexible return options, professional drivers, and well-maintained vehicles. Experience a smooth, safe, and stress-free journey to one of Maharashtra’s most visited spiritual destinations."
    },
    {
        "name": "Pune to Shirdi Innova Crysta Taxi",
        "description": "Travel from Pune to Shirdi in a luxurious Innova Crysta taxi equipped with modern features and ample space. Whether you’re heading for a peaceful darshan or a weekend getaway, our cab offers the perfect blend of comfort and class. With experienced chauffeurs and clean interiors, your ride is guaranteed to be smooth and pleasant."
    },
    {
        "name": "Pune Airport to Shirdi Innova Crysta",
        "description": "Book an Innova Crysta directly from Pune Airport to Shirdi for seamless travel without stopovers. Ideal for out-of-town visitors and tourists arriving by flight, this service offers timely pickups, smooth rides, and comfortable seating. Our drivers monitor your flight schedule for on-time service and ensure you reach Shirdi comfortably and safely."
    },
    {
        "name": "Pune to Shirdi Innova Cab Package",
        "description": "Choose our specially curated Innova cab package for Pune to Shirdi travel, which includes door-to-door service, flexible durations, and affordable pricing. Perfect for families and groups, the package ensures a peaceful journey with spacious seating and reliable chauffeurs who know the best routes to Shirdi."
    },
    {
        "name": "Pune to Shirdi Innova Cab Packages",
        "description": "Explore a variety of Innova cab packages from Pune to Shirdi, including one-day, overnight, and multi-day plans. Each package comes with professional drivers, sanitized vehicles, and transparent pricing. Tailor your trip as per your schedule and experience a worry-free ride to Shirdi with your loved ones."
    },
    {
        "name": "Pune to Shirdi Innova Family Cab",
        "description": "Our Innova family cab service from Pune to Shirdi is designed for those traveling with elders and kids. Spacious seating, a smooth suspension, and air-conditioning make the journey relaxing. Whether it’s a day trip or a weekend pilgrimage, our drivers ensure complete comfort and convenience for the entire family."
    },
    {
        "name": "Pune to Shirdi Innova Affordable Taxi",
        "description": "Get an affordable yet high-quality Innova taxi for your Pune to Shirdi journey. Without compromising on comfort or safety, our affordable cabs provide clean interiors, well-maintained vehicles, and trained drivers. Ideal for solo, group, or family travelers looking for value without cutting corners."
    },
    {
        "name": "Pune to Shirdi Innova Crysta Tour",
        "description": "Book an exclusive Innova Crysta tour from Pune to Shirdi that includes temple visits, sightseeing en route, and return travel. Our premium tour cabs are perfect for devotees looking for a relaxing and spiritual journey with friends or family. Expect punctual service, comfortable travel, and personalized attention."
    },
    {
        "name": "Luxury Innova Crysta Pune to Shirdi",
        "description": "Upgrade your travel experience with our luxury Innova Crysta cab from Pune to Shirdi. Designed for comfort and style, this service is perfect for high-end travel, family trips, or business visits to Shirdi. With plush interiors, bottled water, and courteous drivers, your ride becomes a luxurious retreat on wheels."
    }
],
"tableData": [
    ["Pune to Shirdi Cabs Round Trip", "Pune to Shirdi Innova Crysta Taxi"],
    ["Pune Airport to Shirdi Innova Crysta", "Pune to Shirdi Innova Cab Package"],
    ["Pune to Shirdi Innova Cab Packages", "Pune to Shirdi Innova Family Cab"],
    ["Pune to Shirdi Innova Affordable Taxi", "Pune to Shirdi Innova Crysta Tour"],
    ["Luxury Innova Crysta Pune to Shirdi", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Comfortable & Reliable Pune to Shirdi Innova Cab Booking",
        "WhyChoosedescription": "Prince Cabs offers premium Toyota Innova and Innova Crysta cab services from Pune to Shirdi, ideal for families, devotees, and small groups visiting Sai Baba’s temple. Our spacious, clean, and air-conditioned cabs ensure a peaceful and comfortable journey of approximately 4–5 hours, allowing you to focus on your pilgrimage without any travel worries."
    },
    {
        "WhyChooseheading": "Spacious & Well-Maintained Innova Vehicles",
        "WhyChoosedescription": "Our Innova fleet provides ample seating for 6–7 passengers with large luggage space—perfect for family travel to Shirdi. Each cab is equipped with modern comforts like reclining seats, air conditioning, and music systems to make your journey more relaxing. Vehicles are regularly inspected and sanitized to maintain top condition and hygiene."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pune–Shirdi Route",
        "WhyChoosedescription": "All our drivers are licensed, courteous, and well-versed with the Pune to Shirdi route, including important stopovers like Ranjangaon Ganpati, Ahmednagar, and Shani Shingnapur (optional). Their knowledge of traffic patterns and safe driving ensures timely arrival and a smooth ride across highways and local roads."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way & Round Trips",
        "WhyChoosedescription": "Prince Cabs provides flexible booking options for one-way drops, same-day returns, or multi-day trips from Pune to Shirdi and back. You can book instantly via WhatsApp, call, or our website. We also offer the option to include return via Shani Shingnapur or extend your trip to Nashik or Trimbakeshwar."
    },
    {
        "WhyChooseheading": "Transparent Per Km Pricing & Custom Packages",
        "WhyChoosedescription": "We offer transparent pricing starting from ₹16–₹20/km (depending on model) with no hidden charges. You’ll get an upfront estimate covering driver allowance, tolls, and parking. You can also opt for all-inclusive fixed-rate packages for added convenience."
    },
    {
        "WhyChooseheading": "100% Hygiene & Safety Standards",
        "WhyChoosedescription": "Every Innova cab undergoes deep cleaning before and after trips. Drivers follow hygiene protocols, and vehicles are equipped with essential safety features like seat belts, first aid kits, and ABS, ensuring a safe journey for all passengers—especially important for senior citizens and kids."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Smooth Experience",
        "WhyChoosedescription": "From the moment you enquire to the time you reach Shirdi, our customer support team is available round the clock to assist with bookings, updates, and coordination. We're committed to delivering a stress-free and respectful travel experience during your spiritual journey."
    }
]


















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Innova cab service from Pune to Shirdi?',
        answer: 'Yes, Prince Cabs offers comfortable and spacious Toyota Innova and Innova Crysta cabs for travel from Pune to Shirdi, perfect for pilgrimages and family trips.',
    },
    {
        question: 'What is the fare for Pune to Shirdi Innova cab booking?',
        answer: 'The fare for a one-way trip from Pune to Shirdi in an Innova starts at ₹4,500. Round-trip packages are also available with competitive rates.',
    },
    {
        question: 'How long does it take to reach Shirdi from Pune by Innova?',
        answer: 'The journey typically takes around 4.5 to 5.5 hours depending on traffic, with comfortable highway travel throughout the route.',
    },
    {
        question: 'Can I book an Innova Crysta for Pune to Shirdi travel?',
        answer: 'Absolutely! You can choose between a standard Innova and a premium Innova Crysta, depending on your comfort and budget preferences.',
    },
    {
        question: 'Are round trips and same-day return bookings available?',
        answer: 'Yes, we offer both one-way and same-day return trips from Pune to Shirdi in Innova cabs. Multi-day packages are also available on request.',
    },
    {
        question: 'Is the cab sanitized and driver professional?',
        answer: 'Yes, all cabs are sanitized before the trip, and our drivers are background-verified, experienced, and courteous—ensuring a safe and pleasant journey.',
    },
    {
        question: 'How can I book a Pune to Shirdi Innova cab with Prince Cabs?',
        answer: 'You can book via our website or call our customer support. Share your travel date, time, and passenger count, and we’ll confirm your booking promptly.',
    },
];

const testimonials = [
    {
        name: "Mr. Ramesh Khandekar",
        position: "Devotee",
        text: "We booked an Innova Crysta for our family’s Shirdi trip. The vehicle was comfortable, clean, and the driver was very respectful. Excellent experience!",
        image: "/img/testimonial/testimonial-thumb-shirdi-1.png",
    },
    {
        name: "Ms. Ashwini Pawar",
        position: "Spiritual Traveler",
        text: "Prince Cabs made our Pune to Shirdi journey smooth and stress-free. The Innova was perfect for our group of six. Would definitely book again!",
        image: "/img/testimonial/testimonial-thumb-shirdi-2.png",
    },
];

























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Innova Cab Booking",
  "image": "https://princecab.com/assets/images/pune-to-shirdi-innova-cab.jpg",
  "description": "Book Pune to Shirdi Innova Crysta cab with Prince Cabs for comfortable, reliable, and affordable taxi service. Perfect for round trips, family travel, and packages.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-shirdi-innova-cab-booking"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Shirdi Innova Cab Booking | Comfortable & Affordable | Prince Cabs</title>
  <meta
    name="description"
    content="Book Pune to Shirdi Innova Crysta cab with Prince Cabs for comfortable, reliable, and affordable taxi service. Perfect for round trips, family travel, and packages."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi Cabs Round Trip, Pune to Shirdi Innova Crysta Taxi, Pune Airport to Shirdi Innova Crysta, Pune to Shirdi Innova Cab Package, Pune to Shirdi Innova Cab Packages, Pune to Shirdi Innova Family Cab, Pune to Shirdi Innova Affordable Taxi, Pune to Shirdi Innova Crysta Tour, Luxury Innova Crysta Pune to Shirdi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdiinnovabooking ;